import { render, staticRenderFns } from "./screen-2.vue?vue&type=template&id=394e132c&scoped=true&"
import script from "./screen-2.vue?vue&type=script&lang=js&"
export * from "./screen-2.vue?vue&type=script&lang=js&"
import style0 from "./screen-2.vue?vue&type=style&index=0&id=394e132c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394e132c",
  null
  
)

export default component.exports